import messages from './messages';

export const SHIPPING_VOLUME = 'SHIPPING_VOLUME';
export const FEATURE_INTEREST = 'FEATURE_INTEREST';
export const COMPANY_PHONE = 'COMPANY_PHONE';
export const ONBOARDING = 'onboarding';

export const EnabledOnboardingVariantTypes = {
  ZERO: '0',
  ONE: '1',
  TWO: '2',
  SHOW_PROGRESSIVE_DISCLOSURE: 'show-progressive-disclosure',
  HIDE_PROGRESSIVE_DISCLOSURE: 'hide-progressive-disclosure',
  SHOW_SSO_PROGRESSIVE_DISCLOSURE: 'show-sso-progressive-disclosure',
};

export const variantsThatShowProgressiveDisclosure = [
  EnabledOnboardingVariantTypes.ONE,
  EnabledOnboardingVariantTypes.TWO,
  EnabledOnboardingVariantTypes.SHOW_PROGRESSIVE_DISCLOSURE,
  EnabledOnboardingVariantTypes.SHOW_SSO_PROGRESSIVE_DISCLOSURE,
];

export const ONBOARDING_SETUP_EVENTS = {
  PROGRESSIVE_DISCLOSURE_QUESTION_ANSWERED: 'PROGRESSIVE_DISCLOSURE_QUESTION_ANSWERED',
  PROGRESSIVE_DISCLOSURE_SAVE_JSON_ERROR: 'PROGRESSIVE_DISCLOSURE_SAVE_JSON_ERROR',
  PROGRESSIVE_DISCLOSURE_SETUP_COMPLETE: 'PROGRESSIVE_DISCLOSURE_SETUP_COMPLETE',
};

export const FEATURE_INTERESTS = {
  DISCOUNTED_RATES: 'DISCOUNTED_RATES',
  IMPORT_ORDERS: 'IMPORT_ORDERS',
  AUTOMATE_PROCESSES: 'AUTOMATE_PROCESSES',
  INTERNATIONAL_SHIPPING: 'INTERNATIONAL_SHIPPING',
  RETURNS: 'RETURNS',
  CUSTOM_BRANDING: 'CUSTOM_BRANDING',
};

export const featureOptions = [
  {
    code: FEATURE_INTERESTS.DISCOUNTED_RATES,
    message: messages.shoppingDiscountedRates,
  },
  {
    code: FEATURE_INTERESTS.CUSTOM_BRANDING,
    message: messages.sendingCustomizedShipmentNotifications,
  },
  {
    code: FEATURE_INTERESTS.IMPORT_ORDERS,
    message: messages.importingAndManagingOrders,
  },
  {
    code: FEATURE_INTERESTS.AUTOMATE_PROCESSES,
    message: messages.automatingShippingProcesses,
  },
  {
    code: FEATURE_INTERESTS.INTERNATIONAL_SHIPPING,
    message: messages.shippingInternationally,
  },
  {
    code: FEATURE_INTERESTS.RETURNS,
    message: messages.managingReturnShipments,
  },
];

// Note: The values here are really ranges set up to match the values used by marketing.
// For example, less than 50 really means 0-50, so we pass 50 as the value,
// or 50+ really means 51-500, so we pass 500 as the value, etc. - Greg S. 4/19/2024
export const volumeOptions = [
  { upperLimit: 50, message: messages.lessThanFifty },
  { upperLimit: 500, message: messages.fiftyPlus },
  { upperLimit: 1000, message: messages.fiveHundredPlus },
  { upperLimit: 2000, message: messages.oneThousandPlus },
  { upperLimit: 5000, message: messages.twoThousandPlus },
  { upperLimit: 7500, message: messages.fiveThousandPlus },
  { upperLimit: 7501, message: messages.seventyFiveHundredPlus },
];
